import TableSessionRepository from '../Repository/TableSessionRepository'

class TableSessionService {
    assignMembership(tableSession, membership) {
        return TableSessionRepository.getInstance().assignMembership(tableSession.id, membership?.id)
    }
    applyFreeItem = (tableSessionId, membershipFreeItemId, orderId) => {
        return TableSessionRepository.getInstance().applyFreeItem(tableSessionId, membershipFreeItemId, orderId)
    }
}


const instance = new TableSessionService();
export default instance;